export class TaskQueue {
    private queue = Promise.resolve();
    private isCancelled = false;

    cancelPending() {
        this.isCancelled = true;
        this.queue = Promise.resolve();
    }

    async enqueue<T>(fn: () => Promise<T>): Promise<T> {
        const previous = this.queue;
        let result: T;

        this.queue = (async () => {
            await previous;
            if (this.isCancelled) {
                this.isCancelled = false;
                throw new Error("Task cancelled");
            }
            result = await fn();
        })();

        await this.queue;
        return result!;
    }
}
